var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "row" }, [
    _c("div", { staticClass: "col" }, [
      _c(
        "div",
        { staticClass: "card" },
        [
          _c(
            "card-header",
            { attrs: { title: _vm.$router.currentRoute.meta.title } },
            [
              !_vm.serverError
                ? _c(
                    "router-link",
                    {
                      directives: [
                        {
                          name: "can",
                          rawName: "v-can:edit",
                          value: _vm.permissionPrefix,
                          expression: "permissionPrefix",
                          arg: "edit"
                        }
                      ],
                      staticClass: "btn btn-primary btn-sm",
                      attrs: {
                        to: {
                          name: _vm.routePrefix + ".default.edit",
                          params: { id: _vm.id }
                        }
                      }
                    },
                    [_c("i", { staticClass: "fa fa-edit" })]
                  )
                : _vm._e()
            ],
            1
          ),
          _c("div", { staticClass: "card-body" }, [
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-6" }, [
                _vm.serverError
                  ? _c("div", { staticClass: "alert alert-danger" }, [
                      _c("strong", [
                        _vm._v(_vm._s(_vm.$t("labels.error")) + " : ")
                      ]),
                      _vm._v(" " + _vm._s(_vm.serverError) + " ")
                    ])
                  : _vm._e()
              ])
            ]),
            !_vm.serverError
              ? _c(
                  "div",
                  { staticClass: "row" },
                  [
                    _c("input-number", {
                      attrs: {
                        options: {
                          id: "min_balance_to_keep",
                          transPrefix: _vm.transPrefix + ".fields",
                          label: "min_balance_to_keep",
                          disabled: true
                        }
                      },
                      model: {
                        value: _vm.min_balance_to_keep,
                        callback: function($$v) {
                          _vm.min_balance_to_keep = $$v
                        },
                        expression: "min_balance_to_keep"
                      }
                    }),
                    _c("input-number", {
                      attrs: {
                        options: {
                          id: "min_amount",
                          transPrefix: _vm.transPrefix + ".fields",
                          label: "min_amount",
                          disabled: true
                        }
                      },
                      model: {
                        value: _vm.min_amount,
                        callback: function($$v) {
                          _vm.min_amount = $$v
                        },
                        expression: "min_amount"
                      }
                    }),
                    _c("input-number", {
                      attrs: {
                        options: {
                          id: "max_amount",
                          transPrefix: _vm.transPrefix + ".fields",
                          label: "max_amount",
                          disabled: true
                        }
                      },
                      model: {
                        value: _vm.max_amount,
                        callback: function($$v) {
                          _vm.max_amount = $$v
                        },
                        expression: "max_amount"
                      }
                    }),
                    _c("input-number", {
                      attrs: {
                        options: {
                          id: "returning_terminal_fees",
                          transPrefix: _vm.transPrefix + ".fields",
                          label: "returning_terminal_fees",
                          disabled: true
                        }
                      },
                      model: {
                        value: _vm.returning_terminal_fees,
                        callback: function($$v) {
                          _vm.returning_terminal_fees = $$v
                        },
                        expression: "returning_terminal_fees"
                      }
                    })
                  ],
                  1
                )
              : _vm._e()
          ]),
          _c("div", { staticClass: "card-footer" }, [
            _c("div", { staticClass: "row" }, [
              _c(
                "div",
                { staticClass: "col text-right" },
                [
                  _c(
                    "router-link",
                    {
                      staticClass: "btn btn-neutral btn-sm",
                      attrs: { to: { name: _vm.routePrefix + ".index" } }
                    },
                    [_c("i", { staticClass: "fa fa-arrow-left" })]
                  )
                ],
                1
              )
            ])
          ])
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }